import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { GpsService } from './services/gps.service';

import { JwtModule } from '@auth0/angular-jwt';
import { LoginComponent } from './login/login.component';

import { AuthService } from './services/auth.service';
import { AuthGuard } from './auth.guard';
import { RastreoComponent } from './rastreo/rastreo.component';
import { Error404Component } from './error404/error404.component';

import { ResizableModule } from 'angular-resizable-element';

import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ToastrModule } from 'ngx-toastr';

// News impots
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgSelectModule } from '@ng-select/ng-select';
import { OperadoresService } from './services/operadores.service';
// nuevo
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
// News impots

import {ExcelService} from './services/excel.service';
import { ForgetpassgordComponent } from './forgetpassgord/forgetpassgord.component';
import { UnidadesComponent } from './unidades/unidades.component';
import { GeocercasComponent } from './geocercas/geocercas.component';
import { OperadoresComponent } from './operadores/operadores.component';
import { UsuariosComponent } from './usuarios/usuarios.component';
import { OperadorPipe } from './pipes/operador.pipe';
import { UnidadPipe } from './pipes/unidad.pipe';

export function tokenGetter() {
  return localStorage.getItem('access_token');
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RastreoComponent,
    Error404Component,
    ForgetpassgordComponent,
    UnidadesComponent,
    GeocercasComponent,
    OperadoresComponent,
    UsuariosComponent,
    OperadorPipe,
    UnidadPipe
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    HttpClientJsonpModule,
    FormsModule,
    ResizableModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        whitelistedDomains: ['vigiliner.com.mx:1829'], // Lista blanca que requiere de token
        blacklistedRoutes: [ // no requieren token.
          'vigiliner.com.mx:1829/api/auth',
          'vigiliner.com.mx:1829/api/generarToken',
          'vigiliner.com.mx:1829/api/revisarToken',
          'vigiliner.com.mx:1829/api/solicitudCambioPass'
        ]
      }
    }),
    CommonModule,
    BrowserAnimationsModule, // required animations module
    ToastrModule.forRoot(), // ToastrModule added
    NgxSpinnerModule,
    NgSelectModule,
    NgMultiSelectDropDownModule.forRoot()
  ],
  providers: [
    GpsService,
    ExcelService,
    AuthService,
    AuthGuard,
    OperadoresService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

